import { Directive, HostListener, inject, OnDestroy } from '@angular/core';

import { PendingChangesService } from '../services/pending-changes.service';

@Directive({
  selector: '[libUnsavedChanges]'
})
export class UnsavedChangesDirective implements OnDestroy {
  pendingChangesService = inject(PendingChangesService);

  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: BeforeUnloadEvent): void {
    if (this.pendingChangesService.hasUnsavedChanges()) {
      event.preventDefault();
    }
  }

  ngOnDestroy(): void {
    this.pendingChangesService.setUnsavedChanges(false);
  }
}
